import { gql } from '@apollo/client';

export const CREATE_USER_ACTIVITY = gql`
  mutation createUserActivity($input: UserActivityCreateInput!) {
    createUserActivity(input: $input) {
      _id
      status
      isChallenge
      endDate
      days {
        done
        maxDate
      }
      activity {
        _id
      }
    }
  }
`;

export const COMPLETE_ACTIVITY_DAY = gql`
  mutation completeActivityDay($userActivityId: String!, $entry: String) {
    completeActivityDay(userActivityId: $userActivityId, entry: $entry) {
      _id
      status
      days {
        done
        maxDate
        entry
        dateOfCompletion
      }
    }
  }
`;

export const UPDATE_USER_ACTIVITY = gql`
  mutation updateUserActivity($input: UserActivityUpdateInput!) {
    updateUserActivity(input: $input) {
      _id
      status
    }
  }
`;

export const SET_ACTIVITY_REMINDER = gql`
  mutation setActivityReminder($userActivityId: String!, $reminderEnabled: Boolean!, $reminderTime: String) {
    setActivityReminder(userActivityId: $userActivityId, reminderEnabled: $reminderEnabled, reminderTime: $reminderTime) {
      _id
      reminderEnabled
      reminderTime
    }
  }
`;

/**
 * Records one occurrence of the activity: counted as the day of the running
 * challenge when there is one, kept as a free entry otherwise.
 */
export const RECORD_ACTIVITY_ENTRY = gql`
  mutation recordActivityEntry($activityId: String!, $entry: String) {
    recordActivityEntry(activityId: $activityId, entry: $entry) {
      mode
      userActivity {
        _id
        status
        isChallenge
        days {
          done
          maxDate
          entry
          dateOfCompletion
        }
      }
      entry {
        isChallenge
        day
        date
        entry
      }
    }
  }`;

/** rewrites one recorded entry (a challenge day, 1-based, or a free entry index) */
export const UPDATE_ACTIVITY_ENTRY = gql`
  mutation updateActivityEntry($userActivityId: String!, $day: Int, $entryIndex: Int, $entry: String) {
    updateActivityEntry(userActivityId: $userActivityId, day: $day, entryIndex: $entryIndex, entry: $entry) {
      _id
      status
      days {
        done
        maxDate
        entry
        dateOfCompletion
      }
    }
  }`;
